export enum ERuleType {
  DEDUPLICATE = 'deduplicate',
  TRANSFORM = 'transform',
  FILTER = 'filter',
  DELAY = 'delay',
  RETRY = 'retry',
}

export const DEFAULT_RULE_ORDER: readonly ERuleType[] = [
  ERuleType.DEDUPLICATE,
  ERuleType.TRANSFORM,
  ERuleType.FILTER,
  ERuleType.DELAY,
  ERuleType.RETRY,
];

export enum EFilterScope {
  BODY = 'body',
  HEADERS = 'headers',
  QUERY = 'query',
  PATH = 'path',
}

// Only the statuses fanout may assign; the delivery worker's are deliberately absent.
export enum EPipelineEventStatus {
  QUEUED = 'queued',
  PAUSED = 'paused',
  FILTERED = 'filtered',
  DROPPED = 'dropped',
  ERROR = 'error',
}

export enum EPipelineTransformStatus {
  RAN = 'ran',
  SKIPPED = 'skipped',
  DROPPED = 'dropped',
  FAILED = 'failed',
}

export enum EPipelineConnectionState {
  ACTIVE = 'active',
  PAUSED = 'paused',
  DISABLED = 'disabled',
}

export const TRANSFORM_ERROR_CLASS = 'transform_error';
